module.exports = __webpack_public_path__ + "d4141f528c3c4d277280e8e075d9c208.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-11.png
// module id = 3306
// module chunks = 0